import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/pack_table'
import PackService from '../../network/services/pack'
import { serialize } from '../../network/request'
import PackTable from './PackTable'

const PackPage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Pack
    </Button>
  )

  return (
    <PageHeader title="All Packs" extra={[primaryAction]}>
      <Card>
        <PackTableWrapper />
      </Card>
    </PageHeader>
  )
}

const PackTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(PackService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = PackService.toPaginate(response)

  return (
    <>
      <PackTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <PackTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default PackPage
